module.exports = __webpack_public_path__ + "static/img/com1_1.9ec2e40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/com1_1.jpg
// module id = uK7V
// module chunks = 1